import clsx from 'clsx';
import { motion, AnimatePresence } from 'motion/react';

export default function PlayerAnsweringItem({
  text,
  subtext,
  selected
}: {
  text: string;
  subtext: string;
  selected: boolean;
}) {
  const bgColor = selected ? 'text-gray-200' : 'text-white';

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex items-center justify-center w-full aspect-3/1 relative text-[#20145F]"
    >
      <svg
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-10 -5 300 100"
        className="absolute inset-0 w-full h-full"
      >
        <rect
          x="0"
          y="0"
          width="280"
          height="94"
          rx="47"
          ry="47"
          className={clsx('fill-current', bgColor)}
          style={{ fill: 'none', stroke: '#20145f', strokeMiterlimit: 10, strokeWidth: '1.75px' }}
        />
        <rect
          x="6.5"
          y="6.5"
          width="267"
          height="81"
          rx="40.5"
          ry="40.5"
          style={{ fill: 'none', stroke: '#20145f', strokeMiterlimit: 10, strokeWidth: '1.75px' }}
        />
      </svg>

      <div className="flex-1 relative z-10 text-center max-w-full max-h-full overflow-hidden w-full">
        <h1 className="text-lg sm:text-xl md:text-2xl font-bold truncate">{text}</h1>

        <AnimatePresence mode="wait">
          <motion.div
            key={`status-${subtext}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            <p
              className={`text-base sm:text-lg italic px-2 sm:px-3 py-1 rounded-full inline-block`}
            >
              {subtext}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
